"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ANNUAL_PLACEHOLDER = exports.MONTHLY_PLACEHOLDER = exports.ANNUAL_BASIC_TO_PRO_DISCOUNT = exports.ANNUAL_10_PERCENT_DISCOUNT = exports.MONTHLY_30_PERCENT_DISCOUNT = exports.ANNUAL_30_PERCENT_DISCOUNT = exports.ANNUAL_50_PERCENT_DISCOUNT = exports.ANNUAL_60_PERCENT_DISCOUNT = exports.HSFS_90_PERCENT_DISCOUNT = exports.HSFS_50_PERCENT_DISCOUNT = exports.HSFX_ENTREPRENEUR_DISCOUNT = exports.HSFX_BOOTSTRAP_DISCOUNT = exports.ANNUAL_25_PERCENT_DISCOUNT = exports.ANNUAL_20_PERCENT_DISCOUNT = exports.ANNUAL_NO_DISCOUNT = exports.MONTHLY_50_PERCENT_DISCOUNT = exports.MONTHLY_25_PERCENT_DISCOUNT = exports.MONTHLY_20_PERCENT_DISCOUNT = exports.MONTHLY_NO_DISCOUNT = exports.ANNUAL_40_PERCENT_DISCOUNT = exports.MONTHLY_40_PERCENT_DISCOUNT = exports.ANNUAL_PROMO_NO_DISCOUNT = exports.MONTHLY_PROMO_NO_DISCOUNT = void 0;

var _enviro = _interopRequireDefault(require("self-service-api/core/utilities/enviro"));

var isProd = _enviro.default.isProd();

var MONTHLY_NO_DISCOUNT_PROD = 52;
var MONTHLY_NO_DISCOUNT_QA = 102;
var MONTHLY_PROMO_NO_DISCOUNT_PROD = 76;
var MONTHLY_PROMO_NO_DISCOUNT_QA = 141;
var MONTHLY_20_PERCENT_DISCOUNT_PROD = 57;
var MONTHLY_20_PERCENT_DISCOUNT_QA = 120;
var MONTHLY_25_PERCENT_DISCOUNT_PROD = 54;
var MONTHLY_25_PERCENT_DISCOUNT_QA = 113;
var MONTHLY_50_PERCENT_DISCOUNT_PROD = 61;
var MONTHLY_50_PERCENT_DISCOUNT_QA = 123;
var MONTHLY_30_PERCENT_DISCOUNT_PROD = 65;
var MONTHLY_30_PERCENT_DISCOUNT_QA = 126;
var MONTHLY_40_PERCENT_DISCOUNT_PROD = 74;
var MONTHLY_40_PERCENT_DISCOUNT_QA = 139;
var ANNUAL_20_PERCENT_DISCOUNT_PROD = 50;
var ANNUAL_20_PERCENT_DISCOUNT_QA = 103;
var ANNUAL_25_PERCENT_DISCOUNT_PROD = 55;
var ANNUAL_25_PERCENT_DISCOUNT_QA = 114;
var ANNUAL_BASIC_TO_PRO_DISCOUNT_PROD = 73;
var ANNUAL_BASIC_TO_PRO_DISCOUNT_QA = 138;
var ANNUAL_50_PERCENT_DISCOUNT_PROD = 64;
var ANNUAL_50_PERCENT_DISCOUNT_QA = 127;
var ANNUAL_NO_DISCOUNT_PROD = 51;
var ANNUAL_NO_DISCOUNT_QA = 118;
var ANNUAL_PROMO_NO_DISCOUNT_PROD = 77;
var ANNUAL_PROMO_NO_DISCOUNT_QA = 142;
var ANNUAL_30_PERCENT_DISCOUNT_PROD = 67;
var ANNUAL_30_PERCENT_DISCOUNT_QA = 130;
var ANNUAL_40_PERCENT_DISCOUNT_PROD = 75;
var ANNUAL_40_PERCENT_DISCOUNT_QA = 140;
var HSFX_ENTREPRENEUR_DISCOUNT_QA = 132;
var HSFX_ENTREPRENEUR_DISCOUNT_PROD = 68;
var HSFX_BOOTSTRAP_DISCOUNT_QA = 133;
var HSFX_BOOTSTRAP_DISCOUNT_PROD = 69;
var HSFS_50_PERCENT_DISCOUNT_QA = 135;
var HSFS_50_PERCENT_DISCOUNT_PROD = 71;
var HSFS_90_PERCENT_DISCOUNT_QA = 134;
var HSFS_90_PERCENT_DISCOUNT_PROD = 70;
var ANNUAL_60_PERCENT_DISCOUNT_PROD = 62;
var ANNUAL_60_PERCENT_DISCOUNT_QA = 124;
var ANNUAL_10_PERCENT_DISCOUNT_PROD = 72;
var ANNUAL_10_PERCENT_DISCOUNT_QA = 137;
var MONTHLY_PROMO_NO_DISCOUNT = isProd ? MONTHLY_PROMO_NO_DISCOUNT_PROD : MONTHLY_PROMO_NO_DISCOUNT_QA;
exports.MONTHLY_PROMO_NO_DISCOUNT = MONTHLY_PROMO_NO_DISCOUNT;
var ANNUAL_PROMO_NO_DISCOUNT = isProd ? ANNUAL_PROMO_NO_DISCOUNT_PROD : ANNUAL_PROMO_NO_DISCOUNT_QA;
exports.ANNUAL_PROMO_NO_DISCOUNT = ANNUAL_PROMO_NO_DISCOUNT;
var MONTHLY_40_PERCENT_DISCOUNT = isProd ? MONTHLY_40_PERCENT_DISCOUNT_PROD : MONTHLY_40_PERCENT_DISCOUNT_QA;
exports.MONTHLY_40_PERCENT_DISCOUNT = MONTHLY_40_PERCENT_DISCOUNT;
var ANNUAL_40_PERCENT_DISCOUNT = isProd ? ANNUAL_40_PERCENT_DISCOUNT_PROD : ANNUAL_40_PERCENT_DISCOUNT_QA;
exports.ANNUAL_40_PERCENT_DISCOUNT = ANNUAL_40_PERCENT_DISCOUNT;
var MONTHLY_NO_DISCOUNT = isProd ? MONTHLY_NO_DISCOUNT_PROD : MONTHLY_NO_DISCOUNT_QA;
exports.MONTHLY_NO_DISCOUNT = MONTHLY_NO_DISCOUNT;
var MONTHLY_20_PERCENT_DISCOUNT = isProd ? MONTHLY_20_PERCENT_DISCOUNT_PROD : MONTHLY_20_PERCENT_DISCOUNT_QA;
exports.MONTHLY_20_PERCENT_DISCOUNT = MONTHLY_20_PERCENT_DISCOUNT;
var MONTHLY_25_PERCENT_DISCOUNT = isProd ? MONTHLY_25_PERCENT_DISCOUNT_PROD : MONTHLY_25_PERCENT_DISCOUNT_QA;
exports.MONTHLY_25_PERCENT_DISCOUNT = MONTHLY_25_PERCENT_DISCOUNT;
var MONTHLY_50_PERCENT_DISCOUNT = isProd ? MONTHLY_50_PERCENT_DISCOUNT_PROD : MONTHLY_50_PERCENT_DISCOUNT_QA;
exports.MONTHLY_50_PERCENT_DISCOUNT = MONTHLY_50_PERCENT_DISCOUNT;
var ANNUAL_NO_DISCOUNT = isProd ? ANNUAL_NO_DISCOUNT_PROD : ANNUAL_NO_DISCOUNT_QA;
exports.ANNUAL_NO_DISCOUNT = ANNUAL_NO_DISCOUNT;
var ANNUAL_20_PERCENT_DISCOUNT = isProd ? ANNUAL_20_PERCENT_DISCOUNT_PROD : ANNUAL_20_PERCENT_DISCOUNT_QA;
exports.ANNUAL_20_PERCENT_DISCOUNT = ANNUAL_20_PERCENT_DISCOUNT;
var ANNUAL_25_PERCENT_DISCOUNT = isProd ? ANNUAL_25_PERCENT_DISCOUNT_PROD : ANNUAL_25_PERCENT_DISCOUNT_QA;
exports.ANNUAL_25_PERCENT_DISCOUNT = ANNUAL_25_PERCENT_DISCOUNT;
var HSFX_BOOTSTRAP_DISCOUNT = isProd ? HSFX_BOOTSTRAP_DISCOUNT_PROD : HSFX_BOOTSTRAP_DISCOUNT_QA;
exports.HSFX_BOOTSTRAP_DISCOUNT = HSFX_BOOTSTRAP_DISCOUNT;
var HSFX_ENTREPRENEUR_DISCOUNT = isProd ? HSFX_ENTREPRENEUR_DISCOUNT_PROD : HSFX_ENTREPRENEUR_DISCOUNT_QA;
exports.HSFX_ENTREPRENEUR_DISCOUNT = HSFX_ENTREPRENEUR_DISCOUNT;
var HSFS_50_PERCENT_DISCOUNT = isProd ? HSFS_50_PERCENT_DISCOUNT_PROD : HSFS_50_PERCENT_DISCOUNT_QA;
exports.HSFS_50_PERCENT_DISCOUNT = HSFS_50_PERCENT_DISCOUNT;
var HSFS_90_PERCENT_DISCOUNT = isProd ? HSFS_90_PERCENT_DISCOUNT_PROD : HSFS_90_PERCENT_DISCOUNT_QA;
exports.HSFS_90_PERCENT_DISCOUNT = HSFS_90_PERCENT_DISCOUNT;
var ANNUAL_60_PERCENT_DISCOUNT = isProd ? ANNUAL_60_PERCENT_DISCOUNT_PROD : ANNUAL_60_PERCENT_DISCOUNT_QA;
exports.ANNUAL_60_PERCENT_DISCOUNT = ANNUAL_60_PERCENT_DISCOUNT;
var ANNUAL_50_PERCENT_DISCOUNT = isProd ? ANNUAL_50_PERCENT_DISCOUNT_PROD : ANNUAL_50_PERCENT_DISCOUNT_QA;
exports.ANNUAL_50_PERCENT_DISCOUNT = ANNUAL_50_PERCENT_DISCOUNT;
var ANNUAL_30_PERCENT_DISCOUNT = isProd ? ANNUAL_30_PERCENT_DISCOUNT_PROD : ANNUAL_30_PERCENT_DISCOUNT_QA;
exports.ANNUAL_30_PERCENT_DISCOUNT = ANNUAL_30_PERCENT_DISCOUNT;
var MONTHLY_30_PERCENT_DISCOUNT = isProd ? MONTHLY_30_PERCENT_DISCOUNT_PROD : MONTHLY_30_PERCENT_DISCOUNT_QA;
exports.MONTHLY_30_PERCENT_DISCOUNT = MONTHLY_30_PERCENT_DISCOUNT;
var ANNUAL_10_PERCENT_DISCOUNT = isProd ? ANNUAL_10_PERCENT_DISCOUNT_PROD : ANNUAL_10_PERCENT_DISCOUNT_QA;
exports.ANNUAL_10_PERCENT_DISCOUNT = ANNUAL_10_PERCENT_DISCOUNT;
var ANNUAL_BASIC_TO_PRO_DISCOUNT = isProd ? ANNUAL_BASIC_TO_PRO_DISCOUNT_PROD : ANNUAL_BASIC_TO_PRO_DISCOUNT_QA;
exports.ANNUAL_BASIC_TO_PRO_DISCOUNT = ANNUAL_BASIC_TO_PRO_DISCOUNT;
var MONTHLY_PLACEHOLDER = 99999999998;
exports.MONTHLY_PLACEHOLDER = MONTHLY_PLACEHOLDER;
var ANNUAL_PLACEHOLDER = 99999999999;
exports.ANNUAL_PLACEHOLDER = ANNUAL_PLACEHOLDER;